import {httpRequest} from "../../..//utils/HttpRequest";
import {IPage} from "../../../types/FmsTypes";
import {IConfigSearch,IConfigParams,IConfigDetail,IConfigInsert,IConfigUpdata,IConfigDisable} from "./configTypes"
class ConfigService {
    async page(params:IConfigSearch){
        const apiUrl = "/md/setting/page"
        return await httpRequest.post<IPage<IConfigDetail>>(apiUrl,params)
    }
    async insert(params:IConfigInsert){
        const apiUrl = "/md/setting/insert"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async update(params:IConfigUpdata){
        const apiUrl = "/md/setting/update"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async disable(params:IConfigDisable){
        const apiUrl = "/md/setting/disable"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
}
const configService = new ConfigService()
export {
    configService
}